<template>
  <tbody>
    <tr class="tr-row" :class="{expanded, paid: item.transferStatus === 'paid'}" @click="toggle">
      <td><fa-icon class="tr-chevron" :icon="['fal', 'chevron-right']"/></td>
      <td class="tr-name">
        {{ item.document || 'Repasse' }}
        <span class="tr-sub">{{ itemsLabel }}</span>
      </td>
      <td class="hide-sm tr-num" :class="{'text-error': overdue}">{{ item.dueDate | date }}</td>
      <td class="text-right tr-num">
        <span :class="item.adjustments < 0 ? 'text-error' : 'text-green'" v-if="item.adjustments">
          {{ signedCurrency(item.adjustments) }}
        </span>
        <span class="text-muted" v-else>—</span>
      </td>
      <td class="text-right tr-num text-bold">{{ item.total | currency }}</td>
      <td>
        <status-pill :status="item.transferStatus"/>
        <span class="tr-sub" v-if="item.transferStatus === 'paid' && item.paidAt">
          {{ item.paidAt | date }}
        </span>
      </td>
      <td class="text-right text-nowrap" @click.stop>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                :data-tooltip="payTooltip" :disabled="!canPay || item.transferStatus === 'paid'"
                @click="$emit('pay', item)">
          <fa-icon :icon="['fal', 'hand-holding-usd']"/>
        </button>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                data-tooltip="Recibo do repasse" :disabled="!canPrint"
                @click="$emit('print', item)">
          <fa-icon :icon="['fal', 'print']"/>
        </button>
      </td>
    </tr>
    <bundle-items v-if="expanded" :bundle-id="String(item.bundleId)" :colspan="7"
                  title="Itens consolidados neste repasse"/>
  </tbody>
</template>

<script>
import moment from 'moment';
import StatusPill from './StatusPill.vue';
import BundleItems from './BundleItems.vue';
import { signedCurrency, pluralize } from '../helpers';

export default {
  components: {
    StatusPill,
    BundleItems,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    canPay: {
      type: Boolean,
      default: false,
    },
    canPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    itemsLabel() {
      const counts = this.item.counts || {};
      const parts = [];
      if (counts.cashRegister) {
        const noun = pluralize(counts.cashRegister, 'item do caixa', 'itens do caixa');
        parts.push(`${counts.cashRegister} ${noun}`);
      }
      if (counts.medicalReport) {
        parts.push(`${counts.medicalReport} ${pluralize(counts.medicalReport, 'laudo', 'laudos')}`);
      }
      return parts.length > 0 ? parts.join(' · ') : 'Consolidação manual';
    },
    overdue() {
      return this.item.transferStatus !== 'paid'
        && this.item.dueDate
        && moment(this.item.dueDate).isBefore(moment(), 'day');
    },
    payTooltip() {
      if (this.item.transferStatus === 'paid') {
        return this.item.paidAt ? `Pago em ${moment(this.item.paidAt).format('L')}` : 'Pago';
      }
      return this.canPay ? 'Pagar' : 'Sem permissão para pagar';
    },
  },
  methods: {
    signedCurrency,
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
